/* Peintio cart drawer — 20 sep 2026 (upsell source changed 22 sep). Behaviour the Rebuy Smart Cart had that the
   theme's drawer (app.js CartDrawer) does not: the one-at-a-time upsell card with LÄGG TILL, and "−" on a single
   item removing it. Everything else (open/close, quantity, remove, re-render after add) is the theme's own JS;
   this file only reacts to the drawer being (re)rendered. Loaded with defer after app.js from layout/theme.liquid.
   Markup it fills: <div class="pc-rail" data-product-id data-cart-handles> in snippets/cart-drawer.liquid.
   Upsell products (22 sep, same as Rebuy's cart widget = data source "top sellers", 24 products):
   1) Shopify's best sellers via /collections/all?sort_by=best-selling&section_id=peintio-topsellers-json
      (sections/peintio-topsellers-json.liquid, compact JSON), 2) fallback Shopify recommendations for the
      first cart line, 3) fallback /collections/all/products.json. Cart lines and gift cards are skipped. */
(function () {
  'use strict';
  if (window.peintioCartRail) { return; }
  window.peintioCartRail = true;

  var DRAWER_ID = 'Cart-Drawer';
  var cache = { key: '', products: null };
  var index = 0;

  /* ---------- helpers ---------- */
  /* Rebuy printed "2.997 kr"; the drawer's Liquid does the same (see snippets/cart-drawer.liquid) */
  function money(cents) {
    var kr = Math.round(cents / 100);
    return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  }
  function toCents(v) {
    if (typeof v === 'number') { return v; }
    var f = parseFloat(String(v || '0').replace(',', '.'));
    return isFinite(f) ? Math.round(f * 100) : 0;
  }
  function imageUrl(src, size) {
    if (!src) { return ''; }
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/') === -1) { return src; }
    var joiner = src.indexOf('?') > -1 ? '&' : '?';
    return src + joiner + 'width=' + size;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (html != null) { n.innerHTML = html; }
    return n;
  }

  /* Ajax product (recommendations) and storefront JSON (collections) products differ in price type */
  function normalize(p) {
    var variants = (p.variants || []).filter(function (v) { return v && v.available !== false; }).map(function (v) {
      return {
        id: v.id,
        title: v.title || '',
        price: toCents(v.price),
        compare: v.compare_at_price ? toCents(v.compare_at_price) : 0,
        image: (v.featured_image && v.featured_image.src) || (typeof v.image === 'string' ? v.image : null)
      };
    });
    var image = (typeof p.image === 'string' && p.image) || (p.featured_image && (p.featured_image.src || p.featured_image)) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      url: '/products/' + p.handle,
      image: typeof image === 'string' ? image : '',
      type: p.type || p.product_type || '',
      variants: variants
    };
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* best sellers: Section Rendering API — sort_by on the URL sorts collection.products, the section prints JSON */
  var topSellersPromise = null;
  function fetchTopSellers() {
    if (topSellersPromise) { return topSellersPromise; }
    topSellersPromise = fetchTopSellersNow().then(function (list) {
      if (!list.length) { topSellersPromise = null; }
      return list;
    });
    return topSellersPromise;
  }
  function fetchTopSellersNow() {
    var url = ((window.theme && theme.routes && theme.routes.root_url) || '/').replace(/\/$/, '') + '/collections/all?sort_by=best-selling&section_id=peintio-topsellers-json';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html && html.match(/<script type="application\/json" id="peintio-topsellers-json">([\s\S]*?)<\/script>/);
        if (!m) { return []; }
        try { return JSON.parse(m[1]) || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });
  }

  function loadProducts(productId, exclude) {
    var key = productId + '|' + exclude.join(',');
    if (cache.key === key && cache.products) { return Promise.resolve(cache.products); }
    return fetchTopSellers().then(function (top) {
      if (top.length >= 3) { return top; }
      var rec = productId ? fetchJson('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related') : Promise.resolve(null);
      return rec.then(function (d) {
        var list = top.concat((d && d.products) || []);
        if (list.length >= 3) { return list; }
        return fetchJson('/collections/all/products.json?limit=16').then(function (c) {
          var more = (c && c.products) || [];
          var seen = {};
          list.forEach(function (p) { seen[p.handle] = true; });
          more.forEach(function (p) { if (!seen[p.handle]) { list.push(p); seen[p.handle] = true; } });
          return list;
        });
      });
    }).then(function (list) {
      var seenHandles = {};
      var out = list.map(normalize).filter(function (p) {
        if (!p.variants.length) { return false; }
        if (exclude.indexOf(p.handle) > -1) { return false; }
        if (seenHandles[p.handle]) { return false; }
        seenHandles[p.handle] = true;
        if (/gift|present/i.test(p.type) || /presentkort|gift card/i.test(p.title)) { return false; }
        return true;
      });
      cache = { key: key, products: out };
      return out;
    });
  }

  /* ---------- the card ---------- */
  function chevron(dir) {
    var d = dir === 'prev' ? 'M9 2L4 7l5 5' : 'M5 2l5 5-5 5';
    return '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function render(rail, products, heading) {
    if (!products.length) { rail.innerHTML = ''; return; }
    if (index >= products.length) { index = 0; }
    if (index < 0) { index = products.length - 1; }
    var p = products[index];
    var v = p.variants[0];

    var box = el('div', 'pc-upsell');
    if (heading) { box.appendChild(el('div', 'pc-upsell-heading', esc(heading))); }
    if (products.length > 1) {
      var nav = el('div', 'pc-upsell-nav');
      var prev = el('button', 'pc-upsell-prev', chevron('prev'));
      var next = el('button', 'pc-upsell-next', chevron('next'));
      prev.type = 'button'; next.type = 'button';
      prev.setAttribute('aria-label', 'Föregående'); next.setAttribute('aria-label', 'Nästa');
      prev.addEventListener('click', function () { index--; render(rail, products, heading); });
      next.addEventListener('click', function () { index++; render(rail, products, heading); });
      nav.appendChild(prev); nav.appendChild(next);
      box.appendChild(nav);
    }

    var card = el('div', 'pc-upsell-card');
    var media = el('a', 'pc-upsell-media');
    media.href = p.url;
    var img = document.createElement('img');
    img.src = imageUrl(v.image || p.image, 166);
    img.width = 83; img.height = 83; img.alt = p.title; img.loading = 'lazy';
    media.appendChild(img);
    card.appendChild(media);

    var info = el('div', 'pc-upsell-info');
    var name = el('a', 'pc-upsell-name', esc(p.title));
    name.href = p.url;
    info.appendChild(name);
    var price = el('div', 'pc-upsell-price');
    info.appendChild(price);

    var select = null;
    if (p.variants.length > 1) {
      select = el('select', 'pc-upsell-variant');
      select.setAttribute('aria-label', 'Välj variant');
      p.variants.forEach(function (vv, i) {
        var o = document.createElement('option');
        o.value = String(vv.id); o.textContent = vv.title; if (i === 0) { o.selected = true; }
        select.appendChild(o);
      });
      info.appendChild(select);
    }

    var add = el('button', 'pc-upsell-add', 'Lägg till');
    add.type = 'button';
    info.appendChild(add);
    card.appendChild(info);
    box.appendChild(card);

    function paintPrice() {
      price.innerHTML = esc(money(v.price)) + (v.compare > v.price ? '<s>' + esc(money(v.compare)) + '</s>' : '');
    }
    paintPrice();
    if (select) {
      select.addEventListener('change', function () {
        for (var i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === select.value) { v = p.variants[i]; break; }
        }
        paintPrice();
        if (v.image) { img.src = imageUrl(v.image, 166); }
      });
    }

    add.addEventListener('click', function () {
      if (add.classList.contains('is-busy')) { return; }
      add.classList.add('is-busy');
      var url = ((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (!res || res.status) { throw new Error((res && res.description) || 'add failed'); }
        add.classList.remove('is-busy');
        add.classList.add('is-done');
        add.textContent = 'Tillagd';
        cache = { key: '', products: null };
        try { document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: res } })); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function (err) {
        add.classList.remove('is-busy');
        add.textContent = 'Försök igen';
        if (window.console) { console.warn('peintio-cart add', err); }
        setTimeout(function () { add.textContent = 'Lägg till'; }, 2500);
      });
    });

    rail.innerHTML = '';
    rail.appendChild(box);
  }

  function initRail() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    var rail = drawer.querySelector('.pc-rail');
    if (!rail || rail.getAttribute('data-ready')) { return; }
    rail.setAttribute('data-ready', '1');
    var productId = rail.getAttribute('data-product-id') || '';
    var exclude = (rail.getAttribute('data-cart-handles') || '').split(',').filter(Boolean);
    var heading = rail.getAttribute('data-heading') || '';
    loadProducts(productId, exclude).then(function (products) {
      if (!document.body.contains(rail)) { return; }
      render(rail, products, heading);
    }).catch(function (e) { if (window.console) { console.warn('peintio-cart rail', e); } });
  }

  /* ---------- "−" on quantity 1 removes the line, like Rebuy ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var minus = t.closest('cart-drawer.pc .pc-qty .minus');
    if (!minus) { return; }
    var qs = minus.closest('quantity-selector');
    var input = qs && qs.querySelector('.qty');
    if (!input || Number(input.value) > 1) { return; }
    e.preventDefault();
    e.stopPropagation();
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer && typeof drawer.updateQuantity === 'function') {
      drawer.updateQuantity(input.getAttribute('data-index'), '0');
    }
  }, true);

  /* ---------- stale drawer guard: the markup is rendered with the page, so a cart changed elsewhere
     (Favoriter page, a bfcache-restored page) is re-fetched when the drawer opens. data-count sits on
     .pc-body, INSIDE .cart-drawer-inner, because the theme replaces that wrapper's innerHTML only ---------- */
  var checking = false;
  function syncIfStale() {
    if (checking) { return; }
    var drawer = document.getElementById(DRAWER_ID);
    var inner = drawer && drawer.querySelector('.pc-body[data-count]');
    if (!inner) { return; }
    checking = true;
    fetchJson('/cart.js').then(function (c) {
      checking = false;
      if (!c || typeof c.item_count !== 'number') { return; }
      if (String(c.item_count) !== inner.getAttribute('data-count')) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }).catch(function () { checking = false; });
  }

  /* ---------- run on open and on every re-render ---------- */
  var queued = false;
  function tick() {
    if (queued) { return; }
    queued = true;
    setTimeout(function () { queued = false; try { initRail(); } catch (e) {} }, 30);
  }
  function watch() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    try {
      new MutationObserver(tick).observe(drawer, { childList: true, subtree: true });
    } catch (e) {}
    ['cart-drawer:open', 'cart:item-added', 'line-item:change:end', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, tick);
    });
    document.addEventListener('cart-drawer:open', syncIfStale);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { syncIfStale(); } });
    tick();
    /* warm the best-seller list while the page is idle, so the upsell card is ready when the drawer opens */
    if (drawer.querySelector('.pc-rail')) {
      (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { fetchTopSellers(); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
